import React from 'react'

import { Spacing } from '@interco/inter-ui/components/Spacing'
import { Text } from '@interco/inter-ui/components/Text'
import IconCopy from '@inter/icons/orangeds/LG/copy'
import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import * as S from './styles'

interface CardPixProps {
  title: string
  keyPix: string
  isLoading: boolean
  onCopyKey: () => void
}
export const CardPix = ({ title, keyPix, onCopyKey, isLoading = false }: CardPixProps) =>
  isLoading ? (
    <Skeleton animation="pulse" width="100%" height="108px" />
  ) : (
    <S.Container id={keyPix} onClick={onCopyKey}>
      <Text variant="body-2" colorWeight={500} bold>
        {title}
      </Text>

      <Spacing mb="xs" />
      <S.Row>
        <Text variant="body-3">{keyPix}</Text>
        <IconCopy width={24} height={24} data-testid="left-icon" />
      </S.Row>
    </S.Container>
  )
